import { useState } from "react";
import { useGlobalContext } from "../GlobalContext";

export default function useLogin() {
  const [loading, setLoading] = useState(false);

  const { api, setAccessToken, setAdminId, setAdmin } = useGlobalContext();

  const login = async ({
  mobile,
  password,
  step,
  otp,
  latitude,
  longitude,
}) => {
    setLoading(true);

    try {
      const payload = {
  mobile,
  password,
  step: step.toString(),
  otp: step === 2 ? otp : "",
  latitude: latitude ? latitude.toString() : "0.0",
  longitude: longitude ? longitude.toString() : "0.0",
};

console.log("LOGIN PAYLOAD:", payload);
      const response = await api.post("/api/Admin/v1.0/login", payload, {
        skipAccessDenied: true,
      });

      if (response.data?.responseCode === "00") {
        if (step === 1) {
          return { success: true, nextStep: 2 };
        }

       if (step === 2) {
  const adminData = response.data?.response;

  sessionStorage.setItem("admin", JSON.stringify(adminData));

  // ADD THIS

  setAccessToken(adminData?.accessToken);
  setAdminId(adminData?.userId);
  setAdmin(adminData);

  return { success: true, completed: true };
}
      }

      if (
        response.data?.responseCode === "02" ||
        response.data?.responseCode === "03" ||
        response.data?.responseCode === "98" ||
        response.data?.responseCode === "401"
      ) {
        return {
          success: false,
          message: response.data?.responseMessage || "Access denied",
        };
      }

      return {
        success: false,
        message: response.data?.responseMessage || "Login failed",
      };
    } catch (error) {
      console.error("login error:", error);

      return {
        success: false,
        message: "Login failed. Please try again.",
      };
    } finally {
      setLoading(false);
    }
  };

  return { login, loading };
}